import apiHandler from "../core/apiHandler";

const importPurchaseApi = apiHandler('import-purchases');
export default importPurchaseApi;
